import React from 'react';
import PropTypes from 'prop-types';
import { CircularProgress, Typography } from '@bb-ui/react-library/dist/components';

export const SpinnerScreen = (props) => {
  const { title, description, error, success, className, testId } = props;
  return (
    <div className={`full-screen-wrapper${className ? ' ' + className : ''}`} data-testid={testId ?? 'spinner-screen'}>
      <div className='spinner-wrapper'>
        <CircularProgress label={title} size='large' variant='indeterminate' error={error} success={success}/>
        <Typography variant="subtitle1" className='spinner-desc' gutterBottom><span dangerouslySetInnerHTML={{ __html: description }} /></Typography>
      </div>
    </div>
  );
};

SpinnerScreen.propTypes = {
  title: PropTypes.string,
  description: PropTypes.string,
  error: PropTypes.bool,
  success: PropTypes.bool,
  className: PropTypes.string,
  testId: PropTypes.string,
};
